const Cart = (() => {
  const cartItemCountContainer = document.getElementById("cart-item-count");
  const cartTotalPrice = document.querySelector(".totals__subtotal-value");
  const cartCountContainer = document.querySelector(".cart-count-bubble");
  const emptyCart = document.querySelector(".cart-is-empty");
  const checkoutButton = document.getElementById("checkout");

  const removeButtonQuery = ".cart-item-remove";
  const plusButtonQuery = 'button[name="plus"]';
  const minusButtonQuery = 'button[name="minus"]';
  const inputQuery = 'input[name="updates[]"]';
  const priceContainerQuery = ".item-price-container";

  // update item quantity in the sidecart
  const updateQuantity = (id, quantity, name, currentItem) => {
    currentItem.dataset.isLoading = "true";

    if (name) {
      quantity = Number(currentItem.dataset.cartItemQuantity);

      if (name === "plus") {
        quantity += 1;
      } else if (name === "minus") {
        quantity -= 1;
      } else {
        quantity = 0;
      }
    }

    const body = JSON.stringify({
      id,
      quantity,
    });

    fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } })
      .then((res) => res.json())
      .then(({ item_count, total_price, items }) => {
        currentItem.dataset.isLoading = "false";
        cartItemCountContainer.textContent = item_count;
        cartCountContainer.textContent = item_count;
        cartTotalPrice.textContent = Shopify.formatMoney(total_price);

        console.log('item_count', item_count);

        if (item_count === 0) {
          cartItemCountContainer.textContent = "0";

          emptyCart.classList.remove("hidden");
          checkoutButton.disabled = true;

          if (!cartCountContainer.classList.contains("hidden")) {
            setTimeout(() => cartCountContainer.classList.add("hidden"));
          }

          let giftWrapper = document.querySelector('#main-cart-gift-wrapper');
          if (giftWrapper) {
            giftWrapper.classList.add("hidden");
          }
          let cartItemHeader = document.querySelector('.cart-item-header');
          if (cartItemHeader) {
            cartItemHeader.classList.add("hidden");
          }
          let kangaroo = document.querySelector('.kangaroo-shopping-cart-section');
          if (kangaroo) {
            kangaroo.classList.add("hidden");
          }
        }

        if (name === "remove" || quantity === 0) {
          currentItem.remove();
        } else {
          const item = items.find(
            (r) => currentItem.dataset.cartItemId === r.key
          );
          if (!item) return;

          const formattedPrice = Shopify.formatMoney(
            item.quantity * item.price
          );
          const priceContainers =
            currentItem.querySelectorAll(priceContainerQuery);
          const input = currentItem.querySelector(inputQuery);
          const cannotAddMoreItemsContainer = currentItem.querySelector(
            ".cart-cannot-add-more-items"
          );

          priceContainers.forEach(
            (priceContainer) => (priceContainer.textContent = formattedPrice)
          );
          input.value = item.quantity;
          currentItem.dataset.cartItemQuantity = item.quantity;

          if (
            quantity > item.quantity &&
            cannotAddMoreItemsContainer.classList.contains("hide")
          ) {
            cannotAddMoreItemsContainer.classList.remove("hide");
            setTimeout(
              () => cannotAddMoreItemsContainer.classList.add("hide"),
              3000
            );
          }
        }
      });
  };

  const addEventListeners = () => {
    const items = document.querySelectorAll(".cart-item-container");

    items.forEach((item) => {
      const itemId = item.dataset.cartItemId;
      const removeButton = item.querySelector(removeButtonQuery);
      const plusButton = item.querySelector(plusButtonQuery);
      const minusButton = item.querySelector(minusButtonQuery);
      const input = item.querySelector(inputQuery);

      removeButton.addEventListener("click", () =>
        updateQuantity(itemId, 0, "remove", item)
      );
      plusButton.addEventListener("click", () =>
        updateQuantity(itemId, undefined, "plus", item)
      );
      minusButton.addEventListener("click", () =>
        updateQuantity(itemId, undefined, "minus", item)
      );
      input.addEventListener("input", () =>
        updateQuantity(itemId, Number(input.value), undefined, item)
      );
    });
  };

  return { updateQuantity, addEventListeners };
})();

Cart.addEventListeners();
